module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.audioSrc) ? _c('button', {
    staticClass: "audio-btn",
    style: ({
      height: _vm.height + 'px',
      width: _vm.height + 'px',
      display: _vm.display ? 'inline-block' : 'none'
    }),
    on: {
      "click": _vm.playAudio
    }
  }, [_c('audio', [_c('source', {
    attrs: {
      "src": _vm.audioSrc,
      "type": "audio/mp3"
    }
  })]), _vm._v(" "), _c('inline-svg', {
    staticClass: "speaker-svg",
    attrs: {
      "id": "speaker-svg",
      "src": require('../../assets/svg/play2.svg').default,
      "aria-label": "My image"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.audioSrc) ? _c('div', {
    staticClass: "noaudio"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a2ff84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/audioBtn.vue
// module id = 234
// module chunks = 0 1 2 3 4 5 7 8